<div class="dropdown">
  <div #toggleButton class="ng-content-area">
    <ng-content></ng-content>
  </div>

  <div
      #dropdownContent
      *ngIf="isDropdownOpen"
      (mouseenter)="keepOpen()"
      (mouseleave)="scheduleClose()"
      [class.dropdown-opened]="isDropdownOpen && closeDropdownInternalClicked"
      [class.align-right]="alignRight"
      [class.mac-popover]="macPopover"
      class="dropdown-content">
    <div class="dropdown-top-menu">
    </div>

    <!-- Generic settings menu, reuses the product column / item markup so
         width, hover, spacing and the mobile panel all come from one place. -->
    <div class="section-column-wrapper generic-wrapper" *ngIf="sections"
         [style]="'min-width: ' + 330 * calculatedColumns + 'px;'">
      <div class="section-column" *ngFor="let section of sections; trackBy: trackSection"
           [class.section-column--wide]="section.rows?.length">
        <div *ngIf="section.title" class="section-header">
          <h4>{{ section.title }}</h4>
          <p *ngIf="section.description">{{ section.description }}</p>
          <hr/>
        </div>
        <ng-container *ngTemplateOutlet="genericItems; context: { $implicit: section.items }"></ng-container>
        <ng-container *ngFor="let row of section.rows">
          <div class="generic-subheader" *ngIf="row.header">{{ row.header }}</div>
          <div class="generic-columns">
            <div class="generic-columns-column" *ngFor="let column of row.columns">
              <ng-container *ngTemplateOutlet="genericItems; context: { $implicit: column }"></ng-container>
            </div>
          </div>
        </ng-container>
      </div>
    </div>

    <ng-template #genericItems let-items>
      <ng-container *ngFor="let item of items; trackBy: trackItem">
        <div class="generic-subheader" *ngIf="item.header" [class.generic-subheader--minor]="item.minorHeader">{{ item.label }}</div>
        <a role="button"
           class="dropdown-item generic-item"
           *ngIf="!item.header"
           [class.active]="item.selected"
           [class.disabled]="item.disabled"
           [attr.aria-disabled]="item.disabled || null"
           [class.generic-item--divided]="item.divider"
           (click)="selectItem(item, $event)">
          <div class="dropdown-item-column">
            <span class="generic-moon" *ngIf="item.variant"
                  [ngClass]="'generic-moon--' + item.variant"></span>
            <img class="generic-logo" *ngIf="item.logo && !item.variant"
                 [src]="item.logo" alt="" height="38" loading="lazy"/>
            <span class="generic-swatch" *ngIf="item.swatch && !item.variant && !item.logo"
                  [style.background]="item.swatch"></span>
            <app-icon class="generic-glyph" fixedWidth *ngIf="item.icon && !item.variant && !item.swatch && !item.logo" [name]="item.icon" aria-hidden="true"></app-icon>
          </div>
          <div class="dropdown-item-content">
            <h6>{{ item.label }}</h6>
            <p *ngIf="item.description">{{ item.description }}</p>
            <span class="generic-colors" *ngIf="item.colors?.length" aria-hidden="true">
              <i *ngFor="let c of item.colors" [style.background]="c"></i>
            </span>
          </div>
        </a>
      </ng-container>
    </ng-template>

    <div
        *ngIf="!sections"
        [style]="'min-width: ' + 330 * calculatedColumns + 'px;'"
        class="section-column-wrapper">
      <div
          *ngFor="let productLine of productLines; last as isLastColumn; index as i"
          [class.section-column-right-border]="!(i == calculatedColumns - 1 || isLastColumn)"
          [class]="productLine.color ? productLine.color : ''"
          [style]="getProductLineMaxHeight()"
          class="section-column">
        <div *ngIf="productLine.name" class="section-header">
          <h4>
            {{ productLine.name }}
          </h4>
          <p>
            {{ productLine.description.length < 80 ? productLine.description : productLine.description.substring( 0, 80 ) + '..' }}
          </p>
          <hr/>
        </div>
        <a [attr.href]="productUrl(product, productLine)"
           (click)="closeDropDownInternal(product, productLine, $event)"
           *ngFor="let product of productLine.products; last as isLast; first as isFirst"
           [class]="product.url === URLS.maintenance ? 'maintenance' : ''"
           class="dropdown-item">
          <div class="dropdown-item-column">
            <app-image-content-loader *ngIf="!product.imageLoaded"
                                      [imageContentLoaderClass]="'dropdown-item'"></app-image-content-loader>
            <img
                (load)="setImageLoaded(product)"
                [src]="product.logo"
                [alt]="product.name"
                [class.logo-under-maintenance]="product.url === URLS.maintenance"
                [style]="'display:' + (!product.imageLoaded ? 'none;' : 'block;')"
                height="55"/>
          </div>

          <div class="dropdown-item-content">
            <h6>
              {{ product.name }}
            </h6>
            <p class="dropdown-item-summary">
              {{ product.shortDescription || product.description }}
            </p>
          </div>
        </a>
      </div>
    </div>
  </div>
</div>
